import { Link } from "react-router-dom";
import { buttonVariants } from "../../components/ui/button";
import { IVisitInfo } from "../../types";
import { format } from "date-fns";
import { CircleUserRound } from "lucide-react";

function PatientVisitsCard({
  doctorInfo,
  selectedPatient,
}: IVisitInfo & {
  selectedPatient: string | null;
}) {
  return (
    <li className="max-sm:py-6 max-sm:first:pt-0 sm:rounded-lg sm:border sm:p-2 lg:p-4">
      <div className="flex gap-3">
        {doctorInfo.profilePhoto ? (
          <img
            src={`${doctorInfo.profilePhoto}`}
            alt={doctorInfo.fullName}
            className="size-16 shrink-0 rounded-full object-contain sm:size-20"
          />
        ) : (
          <div className="flex size-16 shrink-0 items-center justify-center rounded-full bg-muted sm:size-20">
            <CircleUserRound
              className="size-full"
              strokeWidth={1}
            />
          </div>
        )}
        <div className="w-full space-y-4">
          <div>
            <h3 className="text-sm font-bold sm:text-lg">
              Dr {doctorInfo.fullName}
            </h3>
            {doctorInfo.specialities && (
              <p className="mb-0.5 text-xs text-muted-foreground sm:text-sm">
                {doctorInfo.specialities.join(", ")}
              </p>
            )}
            <p className="mb-1 text-xs font-bold sm:text-sm">
              {format(new Date(doctorInfo.mostRecentVisitDate), "dd MMM yyyy")}{" "}
              for {selectedPatient}
            </p>
          </div>
          <div className="grid grid-cols-2 gap-2 sm:grid-cols-1 xl:grid-cols-2">
            <Link
              to={`/visit-prescriptions/${doctorInfo.professionalId}`}
              className={buttonVariants({
                className:
                  "mr-2 h-8 w-full cursor-pointer truncate border-primary px-3 text-xs max-sm:h-7 max-sm:px-2 max-sm:text-[11px] max-sm:tracking-tighter",
                variant: "outline",
              })}
            >
              View prescription
            </Link>
            <Link
to={`/doctors/${doctorInfo.professionalId}?backUrl=${encodeURIComponent("/doctors")}`}
className={buttonVariants({
                className:
                  "h-8 w-full truncate px-3 text-xs max-sm:h-7 max-sm:px-2 max-sm:text-[11px] max-sm:tracking-tighter",
              })}
            >
              Book appointment
            </Link>
          </div>
        </div>
      </div>
    </li>
  );
}

export default PatientVisitsCard;
